import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableExternalLinks from './tableExternalLinks';

export default {
  title: 'External Links',
  attributeName: 'externalLinks',
  helpText: '',
  getURL:'appId/areaId/appLink',
  updateURL:'appId/areaId/appLinkUpdate',
  removeURL:'appId/areaId/appLink',
  sessionParams: ['appId', 'areaId'],
  fields: [
    // {
    //   attributeName: 'externalLinks',
    //   type: FormInputTypes.TABLE,
    //   label: '',
    //   helpText: '',
    //   configFile: tableAppLinks,
    // },
    {
      attributeName: 'externalLinksTable',
      type: FormInputTypes.TABLECOMPONENT,
      mode:'NORMAL',
      helpText: '',
      configFile: tableExternalLinks,
    },
  ],
};
